<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zM3cAa/tc-custom/9781781269091.jpg?1705016704456" alt="This image is the cover for the book Addictive Sketcher"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Addictive Sketcher
      </h1>
      <p class="bookDescription body article font2">
        <p>Giving an insight into how this inspiring and talented artist works, The Addictive Sketcher passes on Adebanji Alade's infectious enthusiasm and will have the reader reaching for a pencil or pen to have a go. Adebanji has a skill and a passion for speaking and motivating his audience in a fun and engaging way, and this is reflected in his writing style.   Lively, stimulating and instructive, it is packed with numerous examples of the author’s sketches as well as examples of his vibrant finished paintings. Covering pencils, coloured pencils, charcoal and graphite, along with finished oil paintings, this book provides a fascinating insight into the author’s techniques.   Adebanji’s work covers a broad range of subjects, including landscapes, portraits, crowd scenes, urban scenes and seascapes. He’s particularly well known for his portraits and working outdoors capturing the life of London where he lives. This book includes examples from a range of subject areas.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Adebanji Alade
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Search Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2667906a